var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "reportModal",
      staticClass: "modal fade",
      attrs: {
        id: "reportModal",
        role: "dialog",
        tabindex: "-1",
        "data-backdrop": "static",
        "data-keyboard": "false"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-calendar-preview modal-post-anything"
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "div",
                {
                  staticClass: "close-modal",
                  attrs: { "data-dismiss": "modal" }
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-md-10 col-sm-10 col-xs-8 title-preview"
                      },
                      [
                        _c("h4", {
                          staticClass: "modal-title",
                          domProps: { innerHTML: _vm._s(_vm.title) }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-2 col-sm-2 col-xs-4 text-right" },
                      [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.send($event)
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-times-circle fa-2x"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "close-text" }, [
                              _vm._v(_vm._s(_vm.$i18n.general.close))
                            ])
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.error && !_vm.sent
                ? _c(
                    "div",
                    {
                      staticClass: "alert alert-info",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.error) +
                          "\n                "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.sent
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.msg,
                            expression: "msg"
                          }
                        ],
                        ref: "defaultTextArea",
                        staticClass: "form-control",
                        attrs: {
                          placeholder:
                            _vm.$i18n.content_planner.content_calendar
                              .describe_your_problem
                        },
                        domProps: { value: _vm.msg },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.msg = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.sent
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "alert alert-success" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$i18n.content_planner.content_calendar
                              .thanks_for_report
                          ) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", { staticClass: "row text-right" }, [
                !_vm.sent
                  ? _c("div", { staticClass: "col-xs-12 text-left" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button", disabled: _vm.sending },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.send($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$i18n.general.send))]
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef28fe2e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef28fe2e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/utils/report.vue
// module id = 1189
// module chunks = 28